import { css } from "styled-components/native"

import {
  getAbsoluteLineHeight,
  getTextStyleString,
  TextStyle,
} from "../../lib/text-style"
import { withUnits } from "../../lib/with-units"

export const SMALL_TEXT_STYLE = "caption"

/* NOTE: on Android if the text input grows to fill the whole screen, then
  scrolling becomes pretty much impossible since the text input captures the
  focus every time you try to scroll, unless you scroll along the edges of the
  screen. */
export const MAX_HEIGHT = 250

export const inputStyles = css<{
  $textStyle: TextStyle
  $size: "small" | "medium"
  $maxHeight?: number | string
  $minHeight?: number | string
  $height?: number | string
}>`
  ${(props) => getTextStyleString(props.$textStyle, props.theme)};
  ${(props) => {
    const paddingVertical =
      props.$size === "small"
        ? props.theme.spacing.small
        : // For the medium size vertical padding is a function of line height and
          // input height
          (props.theme.textInput.height -
            getAbsoluteLineHeight(props.$textStyle, props.theme)) /
          2

    // NOTE: padding-vertical doesn't seem to work on multiline text inputs on
    // iOS
    return `
      padding-top: ${paddingVertical}px;
      padding-bottom: ${paddingVertical}px;
    `
  }};
  height: ${(props) => withUnits(props.$height || "auto")};
  max-height: ${(props) => withUnits(props.$maxHeight || "auto")};
  min-height: ${(props) =>
    withUnits(
      props.$height || props.$minHeight || props.theme.textInput.height,
    )};
  border-radius: ${(props) => props.theme.textInput.borderRadius}px;
  background-color: ${(props) => props.theme.textInput.backgroundColor};
  padding-horizontal: ${(props) => props.theme.textInput.paddingHorizontal}px;
  color: ${(props) => props.theme.colors.text.primary};
`
